import { useSelector } from 'react-redux'

import { ANALYTICS_PLANS, ASSIGNMENT_SETTINGS_PLANS } from '@/constants/plans/variables-plans'

const usePermissions = () => {
  const permissionsObject = useSelector(({ permissions }) => permissions)

  const {
    plan = null,
    loaded: permissionsLoaded,
    isStripePlan = null,
    isInstitutionPlan = null,
    subscriptionId = null,
    contact = null,
    refreshDate = null,
    permissions = [],
    hasStudentPortfolios = false,
    type,
    freeOrgTrialExpired = false,
  } = permissionsObject

  const has = permission => permissions?.includes(permission)

  return {
    plan,
    permissionsLoaded,
    isStripePlan,
    refreshDate,
    isInstitutionPlan,
    subscriptionId,
    contact,
    hasGradebook: has(ANALYTICS_PLANS.ANALYTICS_GRADEBOOK),
    hasGoogleClassroomGradePassback: has(ASSIGNMENT_SETTINGS_PLANS.GOOGLE_CLASSROOM_GRADE_PASSBACK),
    hasAssessments: has(ASSIGNMENT_SETTINGS_PLANS.ASSESSMENTS),
    hasSectionAnalytics: has(ANALYTICS_PLANS.ANALYTICS_CLASSROOM_ANALYTICS),
    hasStudentReports: has(ANALYTICS_PLANS.ANALYTICS_STUDENT_PROGRESS_REPORTS),
    permissions: permissions || [],
    hasStudentPortfolios,
    isFreeOrgTrial: type === 'free_org_trial',
    freeOrgTrialExpired,
    permissionsObject: permissionsObject,
  }
}

export default usePermissions
